<template>
  <div class="customer-list salaryCalculationList clearfix">
    <Search @getHeight="getHeight"
            @saveSet="saveSet"
            :tableConfig="tableConfig"
            :tableName="tableName"
            :delPara="delPara"
            :functionBtn="activeName == 0 || activeName == 1"
            ref="Search"
            :isquery="true"
            :isSort="false"
            :isAdd="false"
            :showAdd="false"
            :showSort="false"
            searchName="SalaryCalculatePage">
      <template v-slot:left>
        <el-col :lg="24"
                :md="24"
                :sm="24"
                :xs="24">
          <el-form-item label="关键字"
                        prop="keyWord">
            <el-input @keyup.enter.native="$refs.Search.handleSearch"
                      v-model="searchForm.keyWord"
                      clearable
                      placeholder="请输入关键字查询"></el-input>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:center>
        <el-dropdown style="margin-right: 10px"
                     @command="addHandleClick">
          <el-button size="small "
                     type="success"
                     plain>
            新增<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a"
                              v-if="verifyPermission('Add')">新增汇总工时表</el-dropdown-item>
            <el-dropdown-item command="b"
                              v-if="verifyPermission('Add')">新增明细工时表</el-dropdown-item>
            <el-dropdown-item command="c"
                              v-if="verifyPermission('Add')">新增日结项目</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <el-button
              size="small "
              type="success"
              plain
              @click="addTimesheet(1)"
              v-if="verifyPermission('Add')"
              icon="el-icon-plus"
              >新建汇总工时表</el-button
            >
            <el-button
              size="small "
              type="success"
              plain
              @click="addTimesheet(2)"
              v-if="verifyPermission('Add')"
              icon="el-icon-plus"
              >新建明细工时表</el-button
            > -->
        <el-button size="small "
                   type="success"
                   plain
                   @click="importExport"
                   v-if="(activeName == 0 || activeName == 1) && verifyPermission('Add')"
                   icon="el-icon-upload">上传工时表</el-button>
        <el-button size="small "
                   type="success"
                   plain
                   v-if="verifyPermission('SalarySheetSet')"
                   @click="$router.push('/setPayroll')"
                   icon="el-icon-setting">设置工资条</el-button>
      </template>
      <template v-slot:advancedQuery>
        <el-col :lg="8"
                :md="10"
                :sm="12"
                :xs="24">
          <el-form-item label="创建时间">
            <el-col :span="11">
              <el-date-picker style="width: 100%"
                              v-model="searchForm.stateDate"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="选择开始日期">
              </el-date-picker>
            </el-col>
            <el-col :span="2">~</el-col>

            <el-col :span="11">
              <el-date-picker style="width: 100%"
                              v-model="searchForm.endDate"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="选择结束日期">
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-col>
        <!-- <el-col :lg="4" :md="6" :sm="12" :xs="24">
              <el-form-item label="单位">
                <el-select
                  filterable
                  v-model="searchForm.customerName"
                  clearable
                  style="width: 100%"
                  placeholder="请选择单位"
                >
                  <el-option
                    v-for="item in companyList"
                    :key="item.Id"
                    :label="item.customerName"
                    :value="item.customerName"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
      </template>
    </Search>
    <div class="customer-table-list fr page"
         style="padding: 0">
      <div style="padding: 16px 20px 0">
        <el-steps simple
                  style="width: 70%; margin: 0 auto; margin-bottom: 5px"
                  class="mySteps"
                  :active="4">
          <el-step title="上传工时表"
                   icon="">
            <template slot="icon">
              <span>1</span>
            </template>
          </el-step>
          <el-step title="校验数据">
            <template slot="icon">2</template>
          </el-step>
          <el-step title="计算">
            <template slot="icon">3</template>
          </el-step>
          <el-step title="生成标准工资表">
            <template slot="icon">4</template>
          </el-step>
        </el-steps>
      </div>
      <el-tabs v-model="activeName"
               type="border-card"
               @tab-click="handleClick"
               tab-position="left">
        <el-tab-pane label="全部"
                     name="0"></el-tab-pane>
        <el-tab-pane label="已上传"
                     name="1"></el-tab-pane>
        <el-tab-pane label="已校验"
                     name="4"></el-tab-pane>
        <el-tab-pane label="已计算"
                     name="2"></el-tab-pane>
        <el-tab-pane label="已生成"
                     name="3"></el-tab-pane>
        <el-tab-pane label="已核对"
                     name="6"></el-tab-pane>
        <el-tab-pane label="已发布"
                     name="5"></el-tab-pane>
        <MyTable @sortChange="sortChange"
                 :tableData="tableData"
                 :tableConfig="tableConfig"
                 @inputChange="inputChange"
                 tableType="selection"
                 @selectChange="inputChange"
                 @selectionChange="handleSelectionChange"
                 :height="tableHeight"
                 :width="'width: calc(100% - 92px)'"
                 :indexFlag="true"
                 @EmptyBtn="importExport"
                 tableEmptyText="暂无数据，请上传工时表">
          <template v-slot:index="slotData">
            {{
              ($refs.pagination.currentPage - 1) * $refs.pagination.pageSize +
              slotData.scope.$index +
              1
            }}
          </template>

          <template v-slot:createDate="slotData">
            {{
              slotData.scope.row.createDate &&
              slotData.scope.row.createDate.slice(0, 10)
            }}
          </template>
          <template v-slot:generateDate="slotData">
            {{ slotData.scope.row.generateDate }}
          </template>
          <template v-slot:checkDate="slotData">
            {{ slotData.scope.row.checkDate }}
          </template>
          <template v-slot:releaseDate="slotData">
            {{ slotData.scope.row.releaseDate }}
          </template>
          <template v-slot:reviewDate="slotData">
            {{ slotData.scope.row.reviewDate }}
          </template>
          <template v-slot:calculateState="slotData">
            <el-tag size="small"
                    v-if="slotData.scope.row.calculateState == 1">已上传</el-tag>
            <el-tag size="small"
                    type="warning"
                    v-if="slotData.scope.row.calculateState == 2">已计算</el-tag>
            <el-tag size="small"
                    type="info"
                    v-if="slotData.scope.row.calculateState == 4">已校验</el-tag>
            <el-tag size="small"
                    type="success"
                    v-if="slotData.scope.row.calculateState == 5">已发布</el-tag>
            <el-tag size="small"
                    type="danger"
                    v-if="slotData.scope.row.calculateState == 3">已生成</el-tag>
            <el-tag size="small"
                    type="danger"
                    effect="dark"
                    v-if="slotData.scope.row.calculateState == 6">已核对</el-tag>
          </template>
          <template v-slot:applyDate="slotData">
            {{
              slotData.scope.row.applyDate &&
              slotData.scope.row.applyDate.slice(0, 10)
            }}
          </template>
          <template v-slot:totalCount="slotData">
            {{
              slotData.scope.row.calculateState == 1 ||
              slotData.scope.row.calculateState == 4
                ? "-"
                : slotData.scope.row.totalCount
            }}
          </template>
          <template v-slot:payRollName="slotData">
            {{
              slotData.scope.row.wageTitle ? slotData.scope.row.wageTitle : "-"
            }}
          </template>
          <template v-slot:totalMoney="slotData">
            {{
              slotData.scope.row.calculateState == 1 ||
              slotData.scope.row.calculateState == 4
                ? "-"
                : parseFloat(slotData.scope.row.totalMoney).toFixed(2)
            }}
          </template>
          <template v-slot:operation="slotData">
            <el-button @click="navTimesheet(slotData.scope.row)"
                       size="small"
                       plain
                       icon="el-icon-edit"
                       :loading="submitLoading"
                       v-if="
                slotData.scope.row.calculateState == 1 &&
                verifyPermission('Update') &&
                !slotData.scope.row.fileUrl
              ">编辑</el-button>
            <el-button @click="navDetail(slotData.scope.row)"
                       size="small"
                       plain
                       icon="el-icon-edit"
                       :loading="submitLoading"
                       v-if="
                slotData.scope.row.calculateState == 1 &&
                verifyPermission('Update') &&
                slotData.scope.row.fileUrl
              ">去校验</el-button>
            <el-button @click="navDetail(slotData.scope.row)"
                       size="small"
                       plain
                       icon="el-icon-edit"
                       v-if="
                slotData.scope.row.calculateState == 4 &&
                verifyPermission('Update')
              ">下一步</el-button>
            <el-button @click="navDetail(slotData.scope.row)"
                       plain
                       size="small"
                       icon="el-icon-edit"
                       v-if="
                slotData.scope.row.calculateState == 2 &&
                verifyPermission('Update')
              ">下一步</el-button>

            <el-button @click="navDetail(slotData.scope.row)"
                       plain
                       size="small"
                       icon="el-icon-document-checked"
                       v-if="
                slotData.scope.row.calculateState == 3 &&
                verifyPermission('Select')
              ">去核对</el-button>
            <el-button @click="navDetail(slotData.scope.row)"
                       plain
                       size="small"
                       icon="el-icon-message"
                       v-if="
                slotData.scope.row.calculateState == 6 &&
                verifyPermission('Select')
              ">去发布</el-button>
            <el-button @click="navDetail(slotData.scope.row)"
                       plain
                       size="small"
                       icon="el-icon-view"
                       v-if="
                slotData.scope.row.calculateState == 5 &&
                verifyPermission('Select')
              ">去查看</el-button>
            <!-- <el-button
              @click="deleteCustomer(slotData.scope.row.id)"
              type="danger"
              plain
              size="small"
              icon="el-icon-delete"
              >删除</el-button
            > -->
          </template>
        </MyTable>
      </el-tabs>
      <Pagination class="PagPosition"
                  :total="total"
                  @getNewData="SalaryCalculatePage"
                  ref="pagination" />
    </div>
    <el-dialog title="上传工时表"
               :visible.sync="importVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="880px"
               center
               @close="closeDialog">
      <div class="file">
        <div class="title">
          <span class="num"><i class="el-icon-info"></i></span>
          <span class="tip">请将单位的工时数据拖拽至下方进行上传(系统会自动匹配)</span>
        </div>
        <el-upload class="upload-demo"
                   drag
                   accept=".xls,.xlsx"
                   :http-request="uploadfile"
                   :on-change="handleChange"
                   :limit="2"
                   action=""
                   :auto-upload="false"
                   ref="upload">
          <i class="el-icon-upload"></i>

          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip"
               slot="tip"
               style="color: #e6a23c">
            请选择——实际工资数据从第
            <el-select size="mini"
                       v-model="stateInt"
                       style="width: 60px"
                       placeholder="请选择">
              <el-option label="2"
                         :value="2"></el-option>
              <el-option label="3"
                         :value="3"></el-option>
              <el-option label="4"
                         :value="4"></el-option>
              <el-option label="5"
                         :value="5"></el-option>
            </el-select>
            行开始。
            <div style="margin-top: 5px">
              提示：只能同时上传1个xls或xlsx文件
            </div>
          </div>
        </el-upload>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button size="small "
                   type="primary"
                   :loading="submitLoading"
                   @click="uploadServe">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="新增日结项目"
               :visible.sync="mateVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="400px"
               @close="resetForm">
      <div class="result"
           style="margin-top: 10px">
        <el-form ref="importForm"
                 :model="importForm"
                 :inline="true"
                 :rules="rules"
                 label-width="auto"
                 v-enterToNext="true">
          <el-form-item label="项目名称"
                        prop="projectName">
            <el-input v-model="importForm.projectName"
                      placeholder="请输入项目名称"></el-input>
          </el-form-item>
          <el-form-item label="预计人数"
                        prop="numberOfEstimate">
            <el-input v-model="importForm.numberOfEstimate"
                      placeholder="请输入预计人数"></el-input>
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button size="small "
                   :loading="submitLoading"
                   @click="(mateVisible = false), resetForm">关 闭</el-button>
        <el-button size="small "
                   type="primary"
                   :loading="submitLoading"
                   @click="onSubmit('importForm', 3)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MyTable from "@/components/Table";
import Search from "@/components/Search";
import { verifyPermissionMinix } from "@/utils/mixin";
import store from "@/store/index";
export default {
  components: {
    MyTable,
    Search,
  },
  mixins: [verifyPermissionMinix],

  data () {
    let validateNum = (rule, value, callback) => {
      //使用正则表达式进行验证纯数字
      if (!/^[1-9]{1,}[\d]*$/.test(value)) {
        callback(new Error("预估人数不正确"));
      } else {
        callback();
      }
    };
    return {
      isShow: false,
      tableHeight: "",
      form: {},
      fileVisible: false,
      submitLoading: false,
      selectloading: false,
      importVisible: false,
      stateInt: 2,
      mateVisible: false,
      confirmationVisible: false,
      tableName: "salaryCalculationList",
      tableConfig: [
        {
          field: "createDate",
          label: "创建时间",
          slotName: "createDate",
          width: 120,
          flag: true,
          align: "center",
        },
        {
          field: "projectName",
          label: "项目名称",
          align: "center",
          flag: true,
          style: 1,
          minWidth: 230,
        },
        {
          field: "wageTitle",
          label: "工资条名称",
          align: "center",
          slotName: "payRollName",
          flag: true,
          minWidth: 200,
        },
        {
          field: "calculateState",
          label: "状态",
          align: "center",
          slotName: "calculateState",
          flag: true,
        },
        // {
        //   field: "employingUnit",
        //   label: "单位",
        //   align: "center",
        //   flag: true,
        //   style: 2,
        //   list: [
        //     { text: "选项一", value: true },
        //     { text: "选项二", value: false },
        //   ],
        //   minWidth: 160,
        // },

        {
          field: "totalCount",
          label: "人数",
          align: "center",
          slotName: "totalCount",
          flag: true,
        },
        {
          field: "totalMoney",
          label: "总金额(元)",
          flag: true,
          align: "right",
          slotName: "totalMoney",
          minWidth: 110,
        },
        {
          field: "createUserName",
          label: "上传操作员",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          field: "createDate",
          label: "上传时间",
          align: "center",
          minWidth: 180,
          flag: true,
        },
        {
          field: "reviewUserName",
          label: "校验操作员",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          field: "reviewDate",
          label: "校验时间",
          align: "center",
          slotName: "reviewDate",
          minWidth: 180,
          flag: true,
        },
        {
          field: "calculateUserName",
          label: "计算操作员",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          field: "calculateDate",
          label: "计算时间",
          align: "center",
          minWidth: 180,
          flag: true,
        },
        {
          field: "generateUserName",
          label: "生成操作员",
          align: "center",
          minWidth: 100,
          flag: true,
        },
        {
          field: "generateDate",
          label: "生成时间",
          slotName: "generateDate",
          align: "center",
          minWidth: 180,
          flag: true,
        },
        {
          field: "checkUserName",
          label: "核对操作员",
          align: "center",
          minWidth: 100,
          flag: true,
        },
        {
          field: "checkDate",
          label: "核对时间",
          slotName: "checkDate",
          align: "center",
          minWidth: 180,
          flag: true,
        },
        {
          field: "releaseUserName",
          label: "发布操作员",
          align: "center",
          minWidth: 100,
          flag: true,
        },
        {
          field: "releaseDate",
          label: "发布时间",
          slotName: "releaseDate",
          align: "center",
          minWidth: 180,
          flag: true,
        },
        {
          label: "基本操作",
          slotName: "operation",
          width: 160,
          align: "center",
          flag: true,
          fixed: "right",
        },
        // {
        //   label: "更多操作",
        //   slotName: "moreOperation",
        //   width: 370,
        //   align: "left",
        //   fixed: "right",
        //   flag: true,
        // },
      ],
      tableData2: [],
      tabIndex: 0,
      importForm: { style: "1" },
      addCustomerDrawerShow: false,
      drawerTitle: "",
      total: 0,
      loading: false,
      tableData: [],
      companyList: [],
      searchForm: {},
      customerIds: [],
      customerInfo: null,
      headerList: {},
      headerId: "",
      companyId: "",
      meteId: "",
      totalQuantity: 0,
      succeedCount: 0,
      Ids: [],
      calculateState: "",
      activeName: 0,
      createFlag: 0,
      delPara: {
        data: "",
        controller: "salary",
        action: "SalaryCalculateBatchDelete",
        callback: "SalaryCalculatePage",
      },
      tableId: "",
      exportBtnIsDisabled: false,
      rules: {
        materialState: [
          { required: true, message: "请选择状态", trigger: "blur" },
        ],
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        numberOfEstimate: [
          { required: true, message: "请输入预估人数", trigger: "blur" },
          { validator: validateNum, trigger: ["blur"] },
        ],
        estimateAmount: [
          { required: true, message: "请输入预估人数", trigger: "blur" },
        ],
      },
      importFormrules: {
        num: [{ required: true, message: "请输入单价", trigger: "blur" }],
        factory: [
          {
            required: true,
            message: "请选择单位",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  computed: {},
  activated () {
    this.SalaryCalculatePage();

  },
  mounted () {
    // this.getCompanyList();
    // this.SalaryCalculatePage();
    // document.addEventListener("visibilitychange", this.visibilityState);
    // this.SalaryCalculatePage();
    if (localStorage.getItem(this.tableName)) {
      this.tableConfig = JSON.parse(localStorage.getItem(this.tableName));
      this.sortType = this.tableConfig.pop();
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = type;
        }
      });
    }
  },

  // beforeDestroy() {
  //   document.removeEventListener("visibilitychange", this.visibilityState); //移除监听
  // },
  methods: {
    addHandleClick (v) {
      if (v == "a") {
        this.addTimesheet(1);
      } else if (v == "b") {
        this.addTimesheet(2);
      } else {
        this.DefaultSalaryHeader();

        this.addTimesheet(3);
      }
    },
    //新增工时表
    addTimesheet (type) {
      if (type == 3) {
        this.mateVisible = true;
      } else {
        this.$router.push("/addTimesheet?type=" + type);
      }
    },
    handleChange (file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }

      // this.uploadForm.fileName = file.name;
    },
    reUpload (row) {
      this.importExport();
    },
    closeDialog () {
      this.$refs.upload.clearFiles();
    },

    handleSelectionChange (selection) {
      this.Ids = selection.map((v) => {
        return v.id;
      });
      this.delPara.data = selection.map((v) => {
        return v.id;
      });
    },
    // selectChange(value, field, row) {
    //   let sendData = {
    //     id: row.id,
    //     fieldName: field,
    //     fieldValue: value,
    //   };
    //   this.$api.salary.UpdateUserApplyParent(sendData).then((res) => {
    //     if (res.code == 0) {
    //       this.$message.success("修改成功");
    //     } else {
    //       this.$message.error(res.msg);
    //     }
    //   });
    // },
    // 单字段修改
    inputChange (value, field, row) {
      let sendData = {
        id: row.id,
        fieldName: field,
        fieldValue: value,
      };
      this.$api.salary.UpdateUserApplyParent(sendData).then((res) => {
        if (res.code == 0) {
          this.$message.success("修改成功");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    navTimesheet (row) {
      if (row.type != 1) {
        this.$router.push({
          path: "/addTimesheet",
          query: {
            flag: "edit",
            id: row.id,
            title: row.projectName,
            type: row.dataType,
          },
        });
      } else {
        this.$router.push({
          path: "/addDayTimesheet",
          query: {
            flag: "edit",
            title: row.projectName,
            id: row.id,
          },
        });
      }
    },
    // 跳转详情
    navDetail (row) {
      if (
        row.calculateState == 3 ||
        row.calculateState == 5 ||
        row.calculateState == 6
      ) {
        this.$router.push({
          path: "/salaryCalculationGenerated",
          query: {
            name: row.projectName,
            id: row.id,
            calculateState: row.calculateState,
            time: row.createDate,
          },
        });
      } else {
        if (row.calculateState == 1) {
          this.submitLoading = true;
          let sendData = {
            salaryId: row.id,
            state: 4,
          };
          this.$api.salary.UpdateCalculateState(sendData).then((res) => {
            this.submitLoading = false;
            if (res.code == 0) {
              this.$router.push({
                path: "/salaryCalculationDetail",
                query: {
                  name: row.projectName,
                  id: row.id,
                  calculateState: row.calculateState,
                  time: row.createDate,
                  salaryHeaderMainId: row.salaryHeaderMainId,
                },
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          this.$router.push({
            path: "/salaryCalculationDetail",
            query: {
              name: row.projectName,
              id: row.id,
              calculateState: row.calculateState,
              time: row.createDate,
              salaryHeaderMainId: row.salaryHeaderMainId,
            },
          });
        }

        // const tab = {
        //   path: "/salaryCalculationList",
        //   title: "工资计算",
        // };
        // store.commit("addTab", tab);
        // this.$router.push('')
        // window.open(routeUrl.href, "_blank");
      }
    },

    // 导入表格
    importExport () {
      this.importVisible = true;
    },
    sortChange (column) {
      if (this.sortType == "custom") {
      }
    },
    mateTip () {
      this.$confirm("数据校验成功，可进行计算", "提示", {
        confirmButtonText: "去计算",
        cancelButtonText: "关 闭",
        type: "warning",
      })
        .then(() => {
          this.navDetail(this.row);
        })
        .catch(() => { });
    },

    // 无数据时得提示
    navTip () {
      this.$confirm("可在设置工资条处查看和修改工资条!", "提示", {
        confirmButtonText: "前往设置工资条",
        cancelButtonText: "关 闭",
        type: "warning",
      })
        .then(() => {
          this.$router.push("/setPayroll");
        })
        .catch(() => { });
    },
    // 列的显示与隐藏
    saveSet (checkList, type) {
      if (checkList) {
        this.sortType = type;
        if (this.activeName == 1) {
          this.tableConfig = JSON.parse(JSON.stringify(checkList));
          this.tableConfig.forEach((element) => {
            if (element.sortable) {
              element.sortable = type;
            }
          });
        } else {
          this.tableConfig2 = JSON.parse(JSON.stringify(checkList));
          this.tableConfig2.forEach((element) => {
            if (element.sortable) {
              element.sortable = type;
            }
          });
        }
        this.$forceUpdate();
      }
    },
    getHeight (height) {
      let newHeight = height.replace("px", "");
      this.tableHeight = newHeight - 16 - 51 + "px";
    },
    confirmation (id) {
      this.tableId = id;
      this.confirmationVisible = true;
    },
    uploadServe () {
      this.$refs.upload.submit();
    },
    onSubmit (formName, type) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        let sendData = {
          projectName: this.importForm.projectName,
          numberOfEstimate: this.importForm.numberOfEstimate,
          estimateAmount: this.importForm.estimateAmount,
          salaryHeaderMainId: this.headerId,
          salaryHeader: this.headerList,
        };
        this.$api.salary.SalaryAdd(sendData).then((res) => {
          if (res.code == 0) {
            this.mateVisible = false;
            this.$router.push({
              path: "/addDayTimesheet",
              query: {
                flag: "edit",
                id: res.data,
                type: type,
              },
            });
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    // 获取默认工资条
    DefaultSalaryHeader () {
      // let sendData = {
      //   companyId: JSON.parse(localStorage.getItem("CompanyDetail")).id,
      // };
      this.headerList = {};
      this.$api.salary.DefaultSalaryHeader().then((res) => {
        if (res.code == 0) {
          res.data.forEach((element, i) => {
            if (i < 26) {
              element.field = "cell" + String.fromCharCode(65 + i);
            } else {
              element.field = "cellA" + String.fromCharCode(97 + i - 26);
            }
            this.$set(this.headerList, element.field, element.name.trim());
            // this.headerList[element.field] = element.name.trim();
            this.headerId = element.salaryHeaderMainId;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    uploadfile (fileObj) {
      this.submitLoading = true;
      const formData = new FormData();
      formData.append("file", fileObj.file);
      formData.append("stateInt", this.stateInt);
      this.$api.salary.ImportManHourInfo(formData).then((res) => {
        this.submitLoading = false;
        if (res.code === 0) {
          this.importVisible = false;
          this.SalaryCalculatePage();
          this.$message.success("上传成功");
        } else {
          this.$refs.upload.clearFiles();
          this.$message.error(res.msg);
        }
      });
    },
    handleClick () {
      this.$refs.pagination.currentPage = 1;
      this.$refs.pagination.pageSize = 20;
      this.SalaryCalculatePage();
      this.$forceUpdate();
    },
    clear () {
      this.searchForm.isCooperation = undefined;
    },
    getCompanyList () {
      this.$api.customer.getAllCustomerList().then((res) => {

        if (res.error === false) {
          this.companyList = res.data;
          this.tableConfig[4].list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    EditMaterialState (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        this.submitLoading = true;
        let sendData = {
          id: this.tableId,
          materialState: this.form.materialState,
        };
        this.$api.user.EditMaterialState(sendData).then((res) => {
          this.submitLoading = false;

          if (res.error === false) {
            this.SalaryCalculatePage();
            this.confirmationVisible = false;
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    resetForm () {
      this.importForm = { style: "1" };
    },
    //获取数据
    SalaryCalculatePage () {
      this.loading = true;
      let Data = "";
      let sendData = {};
      sendData = {
        pageIndex: this.$refs.pagination.currentPage,
        pageSize: this.$refs.pagination.pageSize,
        keyWord: this.searchForm.keyWord,
        factoryName: this.searchForm.customerName,
      };

      Data = {
        stateDate: this.searchForm.stateDate,
        endDate: this.searchForm.endDate,
      };
      for (let i in Data) {
        if (Data[i] != undefined) {
          sendData[i] = Data[i];
        }
      }
      if (this.activeName != 0) {
        sendData.calculateState = this.activeName;
      }
      this.$api.salary.SalaryCalculatePage(sendData).then((res) => {
        this.loading = false;
        if (res.error === false) {
          this.tableData = res.data.data;
          if (this.tableData == null || this.tableData.length <= 0) {
            if (this.activeName == 0 && this.createFlag == 0) {
              this.createFlag = 1;
              this.navTip();
            }
          }
          this.total = res.data.count;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 删除公司
    deleteCustomer (id) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const formData = new FormData();
          formData.append("id", id);
          this.$api.salary.SalaryCalculateDelete(formData).then((res) => {
            if (res.error === false) {
              this.SalaryCalculatePage();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang="less" >
.customer-list {
  .upload-demo {
    .el-upload {
      width: 100% !important;
    }
    .el-upload-dragger {
      width: 100% !important;
    }
  }
}
.mateVisible {
  .el-input-group__prepend {
    background-color: #fff !important;
  }
  .el-select .el-input {
    width: 80px;
  }
}
</style>
<style lang="less" scoped>
// .el-form-item__label {
//   width: 60px !important;
// }

.customer-list {
  .file,
  .table {
    width: 100%;
    .title {
      display: flex;
      align-items: center;
      .num {
        // color: rgb(26, 210, 103);
        font-size: 22px;
        margin-right: 5px;
      }
    }
    .tipText {
      span {
        display: inline-block;
        margin-top: 8px;
      }
    }
    .upload-demo {
      width: 100%;
      padding: 10px 70px;
      .el-upload-dragger {
        width: 100% !important;
      }
    }
    .result {
      padding-top: 10px;
    }
  }
}
.btn {
  margin-left: 15px;
}
</style>
